import './App.css';
import {Main} from './components/Main'
import {PosSoftware} from './components/PosSoftware'
import {OnlineStore} from './components/OnlineStore'
import {Multicat} from './components/Multicat'
import AccountRegistration from './components/AccountRegistration';
import React from 'react'
import {
    Routes,
    Route,
    Outlet,
    Link,
    useMatch,
    useResolvedPath,
  } from "react-router-dom";

import Nav from 'react-bootstrap/Nav';


function Layout() {
//   const router = createBrowserRouter([
//     {
//       path: "/",
//       element: <Main/>,
//     },
//     {
//       path: "pos",
//       element: <PosSoftware/>,
//     },
//     {
//       path: "multicat",
//       element: <Multicat/>,
//     },
//     {
//       path: "online",
//       element: <OnlineStore/>,
//     },
//     {
//       path: "registeraccount",
//       element: <AccountRegistration/>,
//     },
//   ]);

  return (
    <div className="App">
      <nav className="navbar fixed-top navbar-expand-lg navbar-light fixed-top" style={{opacity: 1, backgroundColor: 'white'}}>
        <div className="container">
          <img src="/images/BronzeColorTag.png" style={{width: 40, height: 40}}/>
          <a style={{marginLeft: 8, fontSize: 32, fontFamily: 'effraReg'}} className="navbar-brand" href="index.html">BronzeTag</a>
          <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link to="registeraccount">Create a free account</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <Outlet/>
      
      
  
      <footer className="py-5 bg-dark">
        <div className="container">
          <p className="m-0 text-center text-white">Copyright &copy; BronzeTag.com 2024</p>
        </div>
        
      </footer>
    </div>
  );
}

export default Layout;
